import { useState } from "react";

const GUIDES = [
  {
    key: "google",
    label: "Google Agenda",
    link: "https://calendar.google.com/calendar/u/0/r/settings/addcalendar",
    linkLabel: "Ouvrir la page d'ajout Google",
    steps: [
      "Copiez le lien privé ci-dessus (bouton « Copier le lien »).",
      "Ouvrez Google Agenda sur ordinateur, puis cliquez sur le + à côté de « Autres agendas ».",
      "Choisissez « À partir de l'URL ».",
      "Collez le lien, puis cliquez sur « Ajouter l'agenda ».",
      "Vos échéances et rendez-vous apparaissent dans les minutes qui suivent, et se mettent à jour tout seuls.",
    ],
  },
  {
    key: "outlook",
    label: "Outlook",
    link: "https://outlook.live.com/calendar/0/addcalendar",
    linkLabel: "Ouvrir la page d'ajout Outlook",
    steps: [
      "Copiez le lien privé ci-dessus.",
      "Dans Outlook (web ou application), allez dans « Calendrier » puis « Ajouter un calendrier ».",
      "Choisissez « S'abonner à partir du web » (ou « À partir d'Internet »).",
      "Collez le lien, donnez-lui un nom (ex. Odys'Mentoring), puis validez avec « Importer ».",
    ],
  },
  {
    key: "apple",
    label: "Apple / iPhone",
    link: null,
    steps: [
      "Copiez le lien privé ci-dessus.",
      "Sur iPhone : Réglages → Applications → Calendrier → Comptes → Ajouter un compte → Autre → « Ajouter un abonnement à un calendrier ».",
      "Sur Mac : application Calendrier → menu Fichier → « Nouvel abonnement calendrier ».",
      "Collez le lien, validez, puis choisissez une actualisation « Toutes les heures » si l'option est proposée.",
    ],
  },
  {
    key: "yahoo",
    label: "Yahoo / autres",
    link: null,
    steps: [
      "Copiez le lien privé ci-dessus.",
      "Dans Yahoo Agenda : « Actions » → « Suivre un autre agenda » → collez le lien.",
      "Pour tout autre agenda : cherchez l'option « S'abonner à un calendrier » ou « Calendrier par URL / ICS » et collez le lien.",
    ],
  },
];

export default function CalendarSyncGuide() {
  const [open, setOpen] = useState(null);

  return (
    <div className="mt-5 border-t border-gray-100 pt-4" data-testid="calendar-sync-guide">
      <p className="text-sm font-medium text-gray-900 mb-1">Comment l'ajouter à mon agenda ?</p>
      <p className="text-xs text-gray-500 mb-3">
        Une seule manipulation, une seule fois. Ensuite votre agenda se met à jour automatiquement à chaque
        nouvelle échéance ou nouveau rendez-vous — vous n'avez plus rien à faire.
      </p>

      <div className="flex flex-wrap gap-2">
        {GUIDES.map(g => (
          <button
            key={g.key}
            data-testid={`sync-guide-tab-${g.key}`}
            onClick={() => setOpen(open === g.key ? null : g.key)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
              open === g.key ? "bg-[#1a2744] text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            {g.label}
          </button>
        ))}
      </div>

      {GUIDES.filter(g => g.key === open).map(g => (
        <div key={g.key} className="mt-3 rounded-xl bg-[#FFF7E6] border border-[#C9A86A]/30 p-4" data-testid={`sync-guide-steps-${g.key}`}>
          <ol className="space-y-2">
            {g.steps.map((s, i) => (
              <li key={s} className="flex gap-2.5 text-xs text-gray-700 leading-relaxed">
                <span className="shrink-0 w-5 h-5 rounded-full bg-[#C9A86A] text-white flex items-center justify-center text-[10px] font-semibold">
                  {i + 1}
                </span>
                <span>{s}</span>
              </li>
            ))}
          </ol>
          {g.link && (
            <a
              href={g.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`sync-guide-link-${g.key}`}
              className="inline-block mt-3 text-xs font-medium text-[#1a2744] underline"
            >
              {g.linkLabel} ↗
            </a>
          )}
          <p className="text-[11px] text-gray-500 mt-3">
            Ce lien est personnel et en lecture seule : personne ne peut modifier votre parcours avec.
            Si vous l'avez partagé par erreur, cliquez sur « Régénérer le lien » ci-dessous.
          </p>
        </div>
      ))}
    </div>
  );
}
